
import { defineComponent, reactive } from "vue";
import Header from "@/components/Forms/Header.vue";
import BecomeDealerForm from "@/components/Forms/BecomeDealerForm.vue";
import { SendStoreLocatorForm, StoreLocatorTypeForm } from "@/interfaces";
import FormService from "@/services/FormService";

export default defineComponent({
  name: "BecomeDealer",
  components: {
    Header,
    BecomeDealerForm,
  },
  setup() {
    const form = reactive<SendStoreLocatorForm>({
      name: "",
      lastname: "",
      email: "",
      telephone: "",
      province: "",
      city: "",
      organizationName: "",
      type: "",
      dealerType: StoreLocatorTypeForm.NoOne,
      vatNumber: "",
      notes: "",
    });

    const onSubmit = async () => {
      await FormService.send(form);
    };

    return {
      onSubmit,
      form,
    };
  },
});
